import { type HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { classes } from './utils';

export type DialogActionsProps = HTMLAttributes<HTMLDivElement>;

export default function DialogActions({
  className = '',
  ...props
}: DialogActionsProps) {
  return (
    <div className={twMerge(classes.dialogActions, className)} {...props} />
  );
}
